import {Component, OnInit} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';

// Doubles as the "Add Market" name prompt (currentName left blank) - same field, same
// validation, just no rename-specific hint to show when there's nothing being renamed yet.
//
// Simple rename only - no reference cascade. Nothing outside rail.market_assignment_rules
// reads a market by name yet (business rules still read the old CSV-driven tables), so there
// is nothing to cascade to. Revisit this once something does - an un-cascaded rename against
// a table something else depends on would be worse than no rename at all.
@Component({
    selector: 'app-rename-market-dialog',
    templateUrl: './rename-market-dialog.component.html',
    styleUrls: ['./rename-market-dialog.component.scss']
})
export class RenameMarketDialogComponent implements OnInit {
    // Set by the caller right after dialogService.open(), before the dialog is shown.
    currentName = '';
    existingNames: string[] = [];
    confirmLabel = 'Rename';

    newName = '';

    constructor(private dialogRef: DialogRef) {
    }

    ngOnInit(): void {
        this.newName = this.currentName;
    }

    public get isNewMarket(): boolean {
        return !this.currentName;
    }

    public get error(): string | null {
        const trimmed = this.newName.trim();
        if (!trimmed) {
            return 'Enter a name.';
        }
        if (trimmed === 'Unassigned') {
            return '"Unassigned" is reserved.';
        }
        if (trimmed !== this.currentName && this.existingNames.includes(trimmed)) {
            return 'A market with this name already exists.';
        }
        return null;
    }

    public onCancel(): void {
        this.dialogRef.close({confirmed: false});
    }

    public onRename(): void {
        if (this.error) {
            return;
        }
        this.dialogRef.close({confirmed: true, newName: this.newName.trim()});
    }
}
